$(".datepicker").datepicker({
  format: "yyyy-mm-dd",
  autoclose: true
})

$(".datepicker_year").datepicker({
  format: "yyyy",
  minViewMode: 2,
  autoclose: true
})
